import { KanbanWorkLog, KanbanWorkLogResponse, KanbanWorkLogCreate } from "../models/workLog";
import ApiService from "../services/api";

export const fetchKanbanWorkLogs = async (
  occurrenceId: string,
  filters?: { step?: string, user?: string, dateStart?: string, dateEnd?: string },
  page: number = 0,
  size: number = 100,
): Promise<KanbanWorkLog[]> => {
  const apiService = new ApiService();

  try {
    const response = await apiService.get<KanbanWorkLogResponse>(
      `worklog-kanban/occurrence/${occurrenceId}`,
      {
        params: {
          step: filters?.step && filters?.step !== '' ? filters.step : null,
          username: filters?.user && filters?.user !== '' ? filters.user : null,
          changedAtStart: filters?.dateStart && filters?.dateStart !== '' ? new Date(filters.dateStart).toISOString() : null,
          changedAtEnd: filters?.dateEnd && filters?.dateEnd !== '' ? new Date(filters.dateEnd).toISOString() : null,
          page,
          size,
        }
      }
    );
    if (response.status === 200) {
      return response.data?.content ?? [];
    } else {
      return [];
    }
  } catch (error: any) {
    console.error(error);
    return [];
  }
}

export const createKanbanWorkLog = async (occurrenceId: string, workLog: KanbanWorkLogCreate[]): Promise<void> => {
  const apiService = new ApiService();
  try {
    await apiService.post<void>(`/worklog-kanban/occurrence/${occurrenceId}/field-changes`, { fieldChanges: workLog });
  } catch (error: any) {
    console.error(error);
  }
}